/**
 * @module constants/MusicActions
 */

/**
 * The exposed, namespaced Music related actions.
 */
export const MusicActions = Object.freeze({
  GET_LYRICS: 'GET_LYRICS',
  GET_LYRICS_FAIL: 'GET_LYRICS_FAIL',
} as const);

export default MusicActions;
